import React from 'react';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';
import _ from 'lodash';

const AreaChart = (props) => {
    const { chartOptions={}, chartSeries=[] } = props;
    return (
        <Chart
            height="100%"
            options={_.cloneDeep(chartOptions)}
            series={chartSeries.length ? _.cloneDeep(chartSeries) : [{ name: '', data: [] }]}
            type="area"
            width="100%"
        />
    );
};

AreaChart.propTypes = {
    chartOptions: PropTypes.object.isRequired,
    chartSeries: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            data: PropTypes.arrayOf(PropTypes.number).isRequired
        })
    ).isRequired
};

export default AreaChart;
